import React from 'react'
import style from "../Home.module.css";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import Util from "../../../utils/utils";
import {message} from "antd";
import JurisdictionInfo from "./JurisdictionInfo";
import PermissionUtils from "../../../utils/permissionUtils";

class JurisdictionManage extends React.Component {
    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            this.props.history.push("/login")
        } else {
            let userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
            if (userRole !== 0) {
                message.error("你没有权限访问!");
                this.props.history.push("/home");
            } else {
                PermissionUtils.getUserPermission(this, '100010');
            }
        }
    }

    render() {
        return (
            <div className={style['home']}>
                <Header history={this.props.history}/>
                <LeftMenu history={this.props.history}/>
                <JurisdictionInfo history={this.props.history}/>
            </div>
        )
    }
}

export default JurisdictionManage;